__turbopack_context__.v({
  "backButton": "_8I6Xbq_backButton",
  "disabled": "_8I6Xbq_disabled",
  "dragBar": "_8I6Xbq_dragBar",
  "dragHandle": "_8I6Xbq_dragHandle",
  "drawer": "_8I6Xbq_drawer",
  "fadeIn": "_8I6Xbq_fadeIn",
  "feedbackBody": "_8I6Xbq_feedbackBody",
  "headerDivider": "_8I6Xbq_headerDivider",
  "item": "_8I6Xbq_item",
  "itemChevron": "_8I6Xbq_itemChevron",
  "itemIcon": "_8I6Xbq_itemIcon",
  "itemLabel": "_8I6Xbq_itemLabel",
  "overlay": "_8I6Xbq_overlay",
  "section": "_8I6Xbq_section",
  "sectionWithBorder": "_8I6Xbq_sectionWithBorder",
  "slideUp": "_8I6Xbq_slideUp",
  "srOnly": "_8I6Xbq_srOnly",
  "view": "_8I6Xbq_view",
  "viewHeader": "_8I6Xbq_viewHeader",
  "viewTitle": "_8I6Xbq_viewTitle",
  "viewsContainer": "_8I6Xbq_viewsContainer",
  "viewsFeedback": "_8I6Xbq_viewsFeedback",
  "viewsMenu": "_8I6Xbq_viewsMenu",
});
